import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["spinner", "content"]

    connect() { }

    submit(event) {
        const form = event.target.closest('form')

        if (form && event.target.value !== "") {
            this.showSpinner()

            // Écoute la fin de la soumission du formulaire
            form.addEventListener('turbo:submit-end', () => {
                this.hideSpinner()
            }, { once: true })

            form.requestSubmit()
        }
    }

    showSpinner() {
        if (this.hasSpinnerTarget) {
            this.spinnerTarget.classList.remove('hidden')
        }
        if (this.hasContentTarget) {
            this.contentTarget.classList.add('hidden')
        }
    }

    hideSpinner() {
        if (this.hasSpinnerTarget) {
            this.spinnerTarget.classList.add('hidden')
        }
        if (this.hasContentTarget) {
            this.contentTarget.classList.remove('hidden')
        }
    }
}